import { BreadcrumbState } from '../types';

export const breadcrumbStateDefaults: BreadcrumbState = {
  items: []
};
